import { ITaskTypeField } from './taskAdditionalFields';

export interface IRegion {
  id: number;
  regionName: string;
  phoneNumber: string;
  smsNumber: string;
  isCorporate: boolean;
}

export interface IDepartment {
  athenaLocationId?: number;
  athenaLocationName?: string;
  locationId?: number;
  locationName?: string;
  salesForceLocationName?: string;
  locationState?: string;
  regionId?: number;
}

export enum regionEnum {
  Corporate = 1,
  NY = 2,
  FL = 3,
  LA = 4,
  SF = 5,
  Test = 6
}

export interface IConversationSource {
  id: string;
  regionId?: number;
}

export interface ITeam extends IEntity {
  defaultMailbox?: string;
  defaultSmsNumber?: string;
  regionId?: number;
  regionName?: string;
  sharedMailboxes: IConversationSource[];
  sharedSmsNumbers: IConversationSource[];
}

export interface IStaffMember extends IEntity {
  jobTitle?: string;
}

export interface IEntity {
  id: string;
  displayName: string;
  type: string;
}

export interface ITaskType {
  id: number;
  description: string;
  additionalFields?: ITaskTypeField[];
  category?: string;
  isActive?: boolean;
  isSystem?: boolean;
}

export interface ITaskLookupType {
  id: number;
  description: string;
  isActive?: boolean;
}

export interface IRootState {
  isUIVersionOutOfDate: boolean;
  navigationState: { taskId?: string; memberId?: number; createMode?: string };
}

export enum SLA_STATUS {
  BREACH = 'Breach',
  WARNING = 'Warning',
  COMPLIANT = 'Compliant'
}
